import React from "react";
import './App.css';
import { initializeIcons } from "@fluentui/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./Home";
import { CreateAccount } from "./CreateAccount";
import { DemoHome } from "./DemoHome";
import { AppGlobals } from "./AppGlobals";

initializeIcons();
console.log(`App build number: ${AppGlobals.BuildNumber}`);

const buildMode = process.env.REACT_APP_BUILD_MODE;

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={buildMode === "DEMO" ? <DemoHome /> : <Home />}
        />
        <Route path="/CreateAccount" element={<CreateAccount />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;